import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { MultiSelect } from '../multi-select';
import { SkeletonLoader } from '../skeleton-loader';
import { Tooltip } from '../tooltip';
import { FilterControls, TenantFilter } from './filter-types';

import { useTranslation } from 'react-i18next';

const MAX_TEXT_LENGTH = 27;

export const TenantFC = ({
  error,
  data,
  id,
  label,
  loading,
  value,
  setValue,
  placement,
  hideIcon,
  onClose,
  permanent,
  displayMaxItems,
  selectText,
  showInlineClear,
  showOperator,
  wrapperClassName,
  dataTestId,
}: TenantFilter & FilterControls) => {
  const { t } = useTranslation('designSystem');
  return (
    <SkeletonLoader
      status={loading ? 'loading' : error ? 'error' : 'success'}
      error={error}
      type="line"
      key={id}
    >
      <MultiSelect
        dataTestId={dataTestId}
        label={label || t('common:tenants')}
        loading={loading}
        showOperator={showOperator}
        displayButtonClassName={wrapperClassName}
        allowSearch
        options={
          data?.map(({ name, tenantId }) => {
            const isTextTruncated = name && name.length > MAX_TEXT_LENGTH;
            return {
              value: tenantId,
              searchString: `${name}`,
              label: (
                <div className="flex flex-col truncate">
                  <div className="flex items-center gap-1">
                    <div className="mr-1 truncate">{name}</div>
                    {isTextTruncated && (
                      <Tooltip
                        label={name || ''}
                        style={{
                          maxWidth: '500px',
                        }}
                      >
                        <InformationCircleIcon className="h-5 w-5 flex-shrink-0 text-gray-600 dark:text-gray-400" />
                      </Tooltip>
                    )}
                  </div>
                </div>
              ),
              selectedDisplay: (
                <div className="flex items-center gap-1">
                  <div className="truncate">{name}</div>
                </div>
              ),
            };
          }) || []
        }
        mode="multiple"
        showInlineClear={showInlineClear}
        showClear
        showSelectAll
        value={value}
        setValue={setValue}
        hideIcon={hideIcon}
        placement={placement}
        displayMaxItems={displayMaxItems}
        onClose={onClose}
        selectText={selectText}
        permanent={permanent}
        virtualize
      />
    </SkeletonLoader>
  );
};
